/**
 * Conveniently represents flow's "Maybe" type https://flow.org/en/docs/types/maybe/
 *
 * @internal
 */
export type Maybe<T> = null | undefined | T;
